export default "__VITE_ASSET__DKiaL7o5__"